<template>
    <TransitionRoot as="template" :show="visible">
        <Dialog as="div" class="relative z-[100]" @close="close">
            <div class="fixed inset-0 z-[100] overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0"
                        enter-to="opacity-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100"
                        leave-to="opacity-0"
                    >
                        <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </TransitionChild>

                    <span class="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">&#8203;</span>

                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div
                            class="relative inline-block w-full max-w-lg transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:align-middle"
                        >
                            <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
                                    <font-awesome-icon :icon="faTriangleExclamation" class="h-6 w-6 text-amber-600" aria-hidden="true" />
                                </div>
                                <DialogTitle as="h3" class="mt-4 text-center text-base font-semibold leading-6 text-gray-900">
                                    {{ title }}
                                </DialogTitle>
                                <div class="mt-4 text-left text-sm text-gray-700 whitespace-pre-line">
                                    {{ body }}
                                </div>
                            </div>
                            <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                <button type="button" class="primaryButton w-full justify-center sm:ml-3 sm:w-auto" @click="close">
                                    Got it
                                </button>
                            </div>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';

const page = usePage();

const visible = ref(false);

const modal = computed(() => page.props.maintenance_notice_modal ?? {});

const title = computed(() => (typeof modal.value.title === 'string' ? modal.value.title : ''));

const body = computed(() => (typeof modal.value.body === 'string' ? modal.value.body : ''));

watch(
  modal,
  (m) => {
      if (m?.show && m?.title) {
          visible.value = true;
      } else {
          visible.value = false;
      }
  },
  { deep: true, immediate: true }
);

function close() {
    visible.value = false;
}
</script>
